import {useState, useEffect} from 'react';
import {Modal, Button, Row, Col} from 'react-bootstrap';

export const MinimumPolicyConfirmModal = ({
    onChange = () => {},
    popOpen = false,
    setPopOpen = () => {},
    accounts = [],
    onClick = () => {}
  }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  
  const handleShow = () => {
    setShowConfirm(true);
  }
  const handleClose = () => {
    setShowConfirm(false);
    setPopOpen(false);
  }
  
  const buildMessage = () => {
    let str = `Updating the parent organization's minimum policy will `;
    
    if (accounts?.length > 0 ) {
      str += `render policies at ${accounts?.length} organization${accounts?.length > 1 ? 's' : ''} noncompliant.`;
    } else {
      str += `not affect any current policies.`;
    } 

    return str;
  }

  const buildList = () => {
    if(accounts?.length) {
      return (
        <ul>
          {accounts?.map((name) => (
          <li key={name} className="fw-bold">
            {name}
          </li>
          ))}
        </ul>
      )
    }

    return null;
  }

  const handleConfirm = () => {
    onChange();
    if(showConfirm) {
      handleClose();
    }
  };

  useEffect(() => {
    popOpen && handleShow();
  }, [popOpen])


  return (
    <>
      <Button data-testid="" onClick={onClick} className="ms-3">Submit</Button>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showConfirm}
        onHide={handleClose}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="align-items-center">
            <Col className="align-self-center">
              <p><b className="text-center">{buildMessage()}</b></p>
              {buildList()}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button data-testid="cancel-modal" onClick={handleClose} variant="secondary">Cancel</Button> 
            <Button data-testid="confirm-modal" onClick={handleConfirm} className="ms-2">Confirm</Button> 
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MinimumPolicyConfirmModal;
